import React from 'react'
import { Button, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import '../Style/headerGuides.css'
import logoWhite from '../Assets/logo-white.svg'
const HeaderSupport = () => {
  return (
    <Navbar className="bg-body-tertiary position-fixed w-100 header-guides">
      <Container fluid className='d-flex justify-content-between px-4' >
        <Navbar.Brand href="#home">
          <img src={logoWhite} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle />
        <Nav className="justify-content-end text-white" activeKey="/home">
          <NavDropdown title="Applications" id="nav-dropdown" className='text-white'>
            <NavDropdown.Item eventKey="4.1">Markets</NavDropdown.Item>
            <NavDropdown.Item eventKey="4.2">Geotargeting</NavDropdown.Item>
            <NavDropdown.Item eventKey="4.3">Economics & outcomes</NavDropdown.Item>
            <NavDropdown.Item eventKey="4.4">Management</NavDropdown.Item>
          </NavDropdown>
          <Nav.Item>
            <Nav.Link href="/documentation" className='text-white'>Documentation</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/casestudies" eventKey="link-1" className='text-white'>Case Studies</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/guides" eventKey="link-2" className='text-white'>Guides</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/productupdates" eventKey="link-2" className='text-white'>Product Updates</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="link-2" className='text-white'>Question of the Week</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="link-2" className='text-white'>Tickets</Nav.Link>
          </Nav.Item>
        </Nav>
        <Button className='bg-3 text-dark fw-bold' onClick={() => window.location.href = '/home'}>
          Back to Portal
        </Button>
      </Container>
    </Navbar>
  )
}

export default HeaderSupport